import { AdProductConfigBase } from "./AdProductConfig";
import { AdUpgradeKey } from "../schema/AdUpgradeKey";
import {
  AdExpiringUpgradeVariantConfig,
  AdTransientUpgradeVariantConfig,
  AdUpgradeVariantConfig,
} from "./AdUpgradeVariantConfig";

export interface AdUpgradeConfig extends AdProductConfigBase {
  type: "UPGRADE";
  key: AdUpgradeKey;
  variants: AdUpgradeVariantConfig[];
}

export interface AdExpiringUpgradeConfig extends AdUpgradeConfig {
  variants: AdExpiringUpgradeVariantConfig[];
}

export interface AdTransientUpgradeConfig extends AdUpgradeConfig {
  variants: AdTransientUpgradeVariantConfig[];
}

export const AD_UPGRADE_CONFIGS: Record<AdUpgradeKey, AdUpgradeConfig> = {
  HOMEPAGE_SHOWREEL: {
    type: "UPGRADE",
    key: "HOMEPAGE_SHOWREEL",
    title: "Homepage Showreel",
    description: "Be seen on the Horsezone homepage",
    variants: [
      {
        lifeCycle: "EXPIRING",
        key: "15_DAYS",
        label: "15 days",
        price: 79,
        durationDays: 15,
      },
      {
        lifeCycle: "EXPIRING",
        key: "30_DAYS",
        label: "30 days",
        price: 158,
        durationDays: 30,
      },
      {
        lifeCycle: "EXPIRING",
        key: "60_DAYS",
        label: "45 days",
        price: 237,
        durationDays: 60,
      },
    ],
  },
  SEARCH_FEATURE: {
    type: "UPGRADE",
    key: "SEARCH_FEATURE",
    title: "Search Feature",
    description: "Be seen above all other ads on the Search page",
    variants: [
      {
        lifeCycle: "EXPIRING",
        key: "15_DAYS",
        label: "15 days",
        price: 39,
        durationDays: 15,
      },
      {
        lifeCycle: "EXPIRING",
        key: "30_DAYS",
        label: "30 days",
        price: 78,
        durationDays: 30,
      },
      {
        lifeCycle: "EXPIRING",
        key: "60_DAYS",
        label: "45 days",
        price: 117,
        durationDays: 60,
      },
    ],
  },
  URGENT_SALE: {
    type: "UPGRADE",
    key: "URGENT_SALE",
    title: "Urgent Sale",
    description: "Urgent badge and dedicated search position",
    variants: [
      {
        lifeCycle: "EXPIRING",
        key: "15_DAYS",
        label: "15 days",
        price: 29,
        durationDays: 15,
      },
      {
        lifeCycle: "EXPIRING",
        key: "30_DAYS",
        label: "30 days",
        price: 58,
        durationDays: 30,
      },
      {
        lifeCycle: "EXPIRING",
        key: "60_DAYS",
        label: "45 days",
        price: 87,
        durationDays: 60,
      },
    ],
  },
  HIGHLIGHT: {
    type: "UPGRADE",
    key: "HIGHLIGHT",
    title: "Highlight",
    description: "Stand out from other results with a bold outline",
    variants: [
      {
        lifeCycle: "EXPIRING",
        key: "15_DAYS",
        label: "15 days",
        price: 19,
        durationDays: 15,
      },
      {
        lifeCycle: "EXPIRING",
        key: "30_DAYS",
        label: "30 days",
        price: 38,
        durationDays: 30,
      },
      {
        lifeCycle: "EXPIRING",
        key: "60_DAYS",
        label: "45 days",
        price: 57,
        durationDays: 60,
      },
    ],
  },
  FACEBOOK_POST: {
    type: "UPGRADE",
    key: "FACEBOOK_POST",
    title: "Facebook Promotion",
    description: "Promote your ad to Horsezone's 77k+ followers",
    variants: [
      {
        lifeCycle: "TRANSIENT",
        key: "STANDARD",
        label: "",
        price: 79,
      },
    ],
  },
  EMAIL_NEWSLETTER: {
    type: "UPGRADE",
    key: "EMAIL_NEWSLETTER",
    title: "Email Newsletter",
    description: "Featured in Horsezone newsletter with 50k+ subscribers",
    variants: [
      {
        lifeCycle: "TRANSIENT",
        key: "STANDARD",
        label: "",
        price: 49,
      },
    ],
  },
};
